const API_BASE_URL = process.env.REACT_APP_PHP_API_BASE_URL;

export async function getMarketShare(pageData) {
	const response = await fetch(`${API_BASE_URL}/market-share/getMarketShare/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
		// headers: {
		// 	'Content-Type': 'application/json'
		// },
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the information for Market Share.');
	}

	const data = await response.json();

	// if (!data['success']) { // Manually created and returned attributes
	// 	throw new Error(data['status_code'] + ': ' + data['status']);
	// }
	// console.log('DATA');
	// console.log(data);
	return data;
}

export async function getCounties(pageData) {
	const response = await fetch(`${API_BASE_URL}/market-share/getCounties/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the counties for Market Share.');
	}

	const data = await response.json();

	return data;
}

export async function getEnrollment(pageData) {
	const response = await fetch(`${API_BASE_URL}/market-share/getEnrollment/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the Medicare enrollment for Market Share.');
	}

	const data = await response.json();

	return data;
}

export async function getInsights(pageData) {
	const response = await fetch(`${API_BASE_URL}/market-share/getInsights/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the insights for Market Share.');
	}

	const data = await response.json();

	return data;
}

export async function getLargestCounties(pageData) {
	const response = await fetch(`${API_BASE_URL}/market-share/getLargestCounties/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the counties with the largest market share.');
	}

	const data = await response.json();

	return data;
}

export async function getLowestCounties(pageData) {
	const response = await fetch(`${API_BASE_URL}/market-share/getLowestCounties/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the counties with the lowest market share.');
	}

	const data = await response.json();

	return data;
}

